// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".col_text[data-v-f5cbd682],.status_vat_tag[data-v-f5cbd682]{text-align:center}.status_vat_tag[data-v-f5cbd682]{white-space:normal;font-size:16px;margin-right:0;height:300px;padding:40% 10%;width:100%}", ""]);
// Exports
module.exports = exports;
